package ru.villawonka.app.presentation.sharedviews.postList.viewmodel

import ru.villawonka.app.common.mvvm.SingleLiveEvent
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.presentation.model.ConversationDetailsUIModel

sealed class PostListUIEvent : SingleLiveEvent {

    data object ScrollToUp : PostListUIEvent()

    data class OpenPostCardScreen(
        val postId: Int,
        val postType: PostTypeDomain,
    ) : PostListUIEvent()

    data class OpenMediaSliderScreen(
        val initialPage: Int,
        val media: List<String>
    ) : PostListUIEvent()

    data class OpenExternalLink(
        val link: String,
    ) : PostListUIEvent()

    data class PhoneCall(
        val phoneNumber: String
    ) : PostListUIEvent()

    data class OpenConversationDetailsScreen(
        val conversationDetails: ConversationDetailsUIModel
    ) : PostListUIEvent()
}